import { CircularProgress } from "@mui/material";

/**
 * Renders a full-page centered loading spinner for use during page transitions.
 *
 * @component
 *
 * @returns {JSX.Element} React component displaying a centered loading indicator.
 */
const LoadingPage = () => (
  <CircularProgress
    size="5rem"
    sx={{
      position: "absolute",
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      margin: "auto",
    }}
  />
);

export default LoadingPage;
